import client from "../Client/HttpClient";
const ApiPath = "SystemUserLoginSessions";

export default {
  GetSystemUserLoginSessions: (): Promise<any[]> => client.get(`${ApiPath}`),
  GetSystemUserLoginSessionsbyId: (Id: any): Promise<any> => client.get(`${ApiPath}/${Id}`),
};